module.exports = __webpack_public_path__ + "static/img/KS.a80cbf76.png";